import {Component, OnInit} from '@angular/core';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {ActivatedRoute} from '@angular/router';
import {OPCCAT, OPCLOC, OPCNEG} from '../../variables';
import {NgxSpinnerService} from 'ngx-spinner';
import {forkJoin} from 'rxjs';
import {devolverDiaSem} from '../../FriedmanModule/models/semana.model';
import * as moment from 'moment';


@Component({
  selector: 'tiendas-crud',
  templateUrl: '../templates/tiendas.list.template.html'
})
export class TiendasCrudComponent implements OnInit {

  public tiendas: TiendaEntity[] = [];

  rows: any[] = [];
  public tempFullRows: any[] = [];

  columns = [
    {name: 'id'},
    {name: 'Nombre'},
    {name: 'Negocio'},
    {name: 'Categoria'},
    {name: 'Locacion'},
    {name: 'Activo'},
    {name: 'Acciones'}
  ];

  constructor(private ts: TiendaServices) {
  }

  ngOnInit() {
    this.rows = [];
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
      for (let t of this.tiendas) {
        this.rows.push({
          id: t.idDB,
          nombre: t.nombre,
          negocio: t.negocio,
          categoria: t.categoria,
          locacion: t.locacion,
          activo: t.activo,
          acciones: t.id
        });

        this.tempFullRows.push({
          id: t.idDB,
          nombre: t.nombre,
          negocio: t.negocio,
          categoria: t.categoria,
          locacion: t.locacion,
          activo: t.activo,
          acciones: t.id
        });
      }

      this.rows = [...this.rows];

    });
  }

  filtrarTiendas(event) {
    let val = event.target.value.toLowerCase();
    const temp = this.tempFullRows.filter(t => t.nombre.toLowerCase().indexOf(val) !== -1 || !val);
    this.rows = temp;
  }

}

@Component({
  selector: 'tienda-edit',
  templateUrl: '../templates/tienda.edit.template.html'
})
export class TiendaEditComponent implements OnInit {

  tienda: TiendaEntity;

  opcNegocio: string[] = OPCNEG;
  opcLocacion: string[] = OPCLOC;
  opcCategoria: string[] = OPCCAT;

  horario: any[] = [];

  constructor(private ts: TiendaServices, private activeRouter: ActivatedRoute) {

  }

  ngOnInit() {
    let id = +this.activeRouter.snapshot.params.id;
    this.ts.getTienda(id).subscribe(d => {
      this.tienda = d.data.tienda;

      let hor = [];
      console.log(this.tienda.horario);
      if (this.tienda.horario == '[]' || this.tienda.horario == '') {

        for (let i = 0; i < 7; i++) {
          hor.push({
            nombre: devolverDiaSem(i),
            horaInicio: '',
            horaCierre: ''
          });
        }
      } else {
        hor = JSON.parse(this.tienda.horario);
      }

      hor.map((h, i) => {

        this.horario.push({
          nombre: devolverDiaSem(i),
          horaInicio: moment(h.hi, 'HH:mm').format('HH:mm'),
          horaCierre: moment(h.hc, 'HH:mm').format('HH:mm'),
        });
      });
    });
  }


  guardarTienda() {


    let hor: any[] = [];

    this.horario.map(h => {
      hor.push({
        hi: (h.horaInicio == 'Invalid date') ? '' : h.horaInicio,
        hc: (h.horaCierre == 'Invalid date') ? '' : h.horaCierre
      });
    });
    console.log(this.horario);
    console.log(hor);
    this.tienda.horario = JSON.stringify(hor);
    this.ts.updateTienda(this.tienda).subscribe(d => {
      console.log(d);
      alert('Tienda actualizada exitosamente');
    });
  }

}

@Component({
  selector: 'horarios-tiendas',
  templateUrl: '../templates/horarios.tiendas.template.html'
})
export class HorariosTiendaComponent implements OnInit {

  public tiendas: TiendaEntity[] = [];
  public datosCargados: any;
  public separador: string = '';

  constructor(private spinner: NgxSpinnerService, private ts: TiendaServices) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      // console.log(d);
      this.tiendas = d.data.tiendas;
      this.spinner.hide();
    });
  }

  cargarDatos($event) {
    // console.log($event);
    this.datosCargados = $event;

  }

  cargarHorarios() {
    this.asignarHorarios();

  }

  asignarHorarios() {
    if (this.datosCargados) {

      let files = this.datosCargados.srcElement.files;


      let datos: any[] = [];


      let input = this.datosCargados.target;
      let reader = new FileReader();

      if (input.files.length > 0) {
        let tiCarg = 0;
        let cantTiendas = 0;
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');

          let actualizaciones: any[] = [];

          // console.log(filas[2].split(this.separador));

          // las primeras dos filas se ignoran
          for (let i = 2; i < filas.length; i++) {
            if (filas[i] != '') {
              cantTiendas++;
              let dt = filas[i].split(this.separador);

              let tienda = this.tiendas.find(t => t.idDB == dt[0]);
              if (tienda) {

                let horario = [];
                if (tienda.horario != '')
                  horario = JSON.parse(tienda.horario);

                if (horario.length == 0) {
                  for (let i = 0; i < 7; i++) {
                    horario.push({
                      hi: '',
                      hc: ''
                    });
                  }
                }
                // console.log(horario);
                // se ignora el primer indice dado que es el id de la tienda
                horario.map((h, i) => {
                  h.hi = dt[((i + 1) * 2) - 1];
                  h.hc = dt[((i + 1) * 2)];
                });
                // if (tienda.idDB == '004')
                //   console.log(horario);
                tienda.horario = JSON.stringify(horario);
                actualizaciones.push(this.ts.updateTienda(tienda));
                tiCarg++;
              }


            }
          }

          forkJoin(actualizaciones).subscribe(d => {
            console.log(d);
            alert(`Se cargaron ${tiCarg} tiendas de ${cantTiendas} tiendas`);
          });


        };
      }
    }
  }

}
